import * as mutations from "./mutations-types";
import Properties from "@/services/properties";

export async function getSearchFilterOptions({ commit, state }) {
  try {
    if (!state.adTypes.length || !state.propertyTypes.length) {
      const response = await Properties.filter({
        params: { filter: {}, onlyOptions: true }
      });
      const { propertyTypes, searchFor, zones } = response.data.filter;
      commit(mutations.SET_SEARCH_AD_TYPES, searchFor);
      commit(mutations.SET_SEARCH_PROPERTY_TYPES, propertyTypes);
      commit(mutations.SET_SEARCH_ZONES, zones);
    }
  } catch (error) {
    console.log(error);
  }
}
